/**
 * shopify-cart-remove-free.js
 * Entfernt alle Produkte mit Preis 0 aus dem Shopify-Warenkorb.
 *
 * ShopifyCartRemoveFree.run();           // einmal ausführen
 * ShopifyCartRemoveFree.auto();          // automatisch bei jedem Cart-Update
 * ShopifyCartRemoveFree.stop();          // auto stoppen
 */
(function () {
    'use strict';

    var _interval = null;

    function run() {
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            var updates = {};
            var removed = [];
            cart.items.forEach(function (item) {
                if (item.final_line_price === 0) {
                    updates[item.key] = 0;
                    removed.push(item.title);
                }
            });
            if (removed.length === 0) {
                console.log('[cart-clean] Keine 0€-Produkte gefunden');
                return;
            }
            return fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ updates: updates })
            }).then(function () {
                console.log('[cart-clean] Entfernt:', removed.join(', '));
            });
        }).catch(function (err) {
            console.error('[cart-clean] Fehler:', err);
        });
    }

    function auto(ms) {
        stop();
        run();
        _interval = setInterval(run, ms || 3000);
        console.log('[cart-clean] Auto-Modus aktiv');
    }

    function stop() {
        if (_interval) { clearInterval(_interval); _interval = null; }
    }

    window.ShopifyCartRemoveFree = { run: run, auto: auto, stop: stop };
})();
